import { Autocomplete, TextField } from '@mui/material';
import { useController } from 'react-hook-form';

export function AutocompleteController({
  name,
  label,
  control,
  disabled,
  rules,
  fullWidth,
  options,
  single,
  freeSolo,
  selectOnFocus,
  clearOnBlur,
  handleHomeEndKeys,
  sx,
}) {
  const {
    field: { value, disabled: isDisabled, onChange, ref },
    fieldState: { error, invalid },
  } = useController({
    name,
    control,
    rules,
    defaultValue: single ? null : [],
    disabled,
  });

  function handleChange(_, selections) {
    if (single) {
      onChange(selections?.value ?? selections);
    } else {
      onChange(selections.map((selection) => selection?.value ?? selection));
    }
  }

  function isOptionEqualToValue(option, selected) {
    return (option.value ?? option) === (selected.value ?? selected);
  }

  function getOptionLabel(option) {
    return (
      option.label ?? options.find((o) => o.value === option)?.label ?? option
    );
  }

  function renderInput(params) {
    return (
      <TextField
        inputRef={ref}
        label={label}
        error={invalid}
        helperText={error?.message}
        {...params}
      />
    );
  }

  return (
    <Autocomplete
      value={value}
      size="small"
      disabled={isDisabled}
      fullWidth={fullWidth}
      multiple={!single}
      freeSolo={freeSolo}
      selectOnFocus={selectOnFocus}
      clearOnBlur={clearOnBlur}
      handleHomeEndKeys={handleHomeEndKeys}
      onChange={handleChange}
      options={options}
      isOptionEqualToValue={isOptionEqualToValue}
      getOptionLabel={getOptionLabel}
      renderInput={renderInput}
      sx={{ minWidth: 240, ...sx }}
    />
  );
}
